<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-sm" role="document">
			<div v-if="data" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4 class="modal-title">Proyecto {{ $platform.setting.number_symbol }}{{ data.id }}</h4>
				</div>
				<div class="list-group m-b-0">
					<router-link @click.native="close" :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects/' + data.id" class="list-group-item">
						<i class="fa fa-eye fa-fw" aria-hidden="true"></i>
						Ver
					</router-link>

					<router-link @click.native="close" :disabled="data.project_status_id == 3 || data.project_status_id == 4" :class="{ 'disabled': data.project_status_id == 3 || data.project_status_id == 4 }" :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects/'+data.id+'/edit'" class="list-group-item">
						<i class="ti-pencil-alt fa-fw"></i>
						Editar
					</router-link>

					<button type="button" @click="destroy(data)" class="list-group-item" :class="{ 'disabled' : data.tasks_count > 0 }">
						<i class="icon-trash fa-fw"></i>
						Eliminar
					</button>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth'],
		components: {
		},
		data () {
			return {
				modal: {
					selector: 'customers-actions-' + new Date().getTime(),
				},

				data: null
			}
		},
		methods: {
			open(data) {
				if(data) {
					this.data = data
				} else {
					this.data = null
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			destroy(data) {
				this.close()
				this.$emit('destroy', data)
			},
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Actions.vue